import {QueryClient, QueryClientProvider} from '@tanstack/react-query'
import {Suspense} from 'react'
import {Outlet} from 'react-router-dom'
import { I18nProvider } from 'sr/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from 'sr/layout/master-layout'
import {ReadOnlyModeProvider} from 'sr/helpers/ui-components/ReadOnlyModeProvider'
// import {ReactQueryDevtools} from '@tanstack/react-query-devtools'

const App = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: false, // Disable retries by default
      },
      mutations: {
        retry: false, // Disable retries for mutations by default
      },
    },
  })
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <ReadOnlyModeProvider>
        <I18nProvider>
          <LayoutProvider>
            <QueryClientProvider client={queryClient}>
              <Outlet />
              {/* <ReactQueryDevtools initialIsOpen={false} /> */}
            </QueryClientProvider>
          </LayoutProvider>
        </I18nProvider>
      </ReadOnlyModeProvider>
    </Suspense>
  )
}

export {App}
